import PropTypes from 'prop-types';
import { FaFolder } from 'react-icons/fa';
import DropdownWithIcon from '../../components/DropdownWithIcon';

// A destination folder in the system's input style. `options` come from
// libraryTree.folderOptions ([{ id, label }], id null = the root).
const FolderSelect = ({ options, value, onChange }) => (
  <DropdownWithIcon
    icon={<FaFolder color="#1FB5A3" />}
    aria-label="תיקייה"
    value={value ?? ''}
    onChange={(e) => onChange(e.target.value || null)}
    // The root's value is '', so the dropdown's own empty placeholder option
    // would hide it.
    displayEmpty={false}
  >
    {options.map(option => (
      <option key={option.id ?? 'root'} value={option.id ?? ''}>{option.label}</option>
    ))}
  </DropdownWithIcon>
);

FolderSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string, label: PropTypes.string })).isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};
export default FolderSelect;
